import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getCookieValue } from "app/common/utils/cookie.util";
import { environment } from "environments/environment";
import { BehaviorSubject, first, from, Observable, ReplaySubject, tap } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { ContractsService } from "../contract/contracts.service";

// const Web3 = require('web3');
@Injectable({
    providedIn: 'root'
})

export class Web3Service {
    private web3: any;
    accountChanged: BehaviorSubject<boolean> = new BehaviorSubject(false);
    // signStatus: BehaviorSubject<Map<eStatus, any>> = new BehaviorSubject<Map<eStatus, any>>(new Map<eStatus, any>());
    signStatus: BehaviorSubject<iStatus> = new BehaviorSubject<iStatus>({ status: eStatus.notinit, value: null });
    private _balanceBnB: ReplaySubject<{ float: number, wei: string }> = new ReplaySubject<{ float: number, wei: string }>(1);
    private networkName: string;

    constructor(
        private _httpClient: HttpClient,
    ) { }



    getWeb3() {
        return this.web3;
    }

    setWeb3(web3: any) {
        this.web3 = web3;
    }
    // setWeb3(web3: any) {
    //     this.web3 = web3;
    //     this.getChainId().subscribe(netId => {
    //         let _networkName = networkName[netId.toString()];
    //         this.contractsService.setContractInstancesByNetwork(web3, _networkName);
    //         this.web3.currentProvider.on('accountsChanged', (accounts) => {
    //             console.log('accountsChanged', accounts);
    //             // this.disconnectProvider();
    //             this.accountChanged.next(true);
    //         });
    //         this.web3.currentProvider.on('networkChanged', (accounts) => {
    //             console.log('networkChanged', accounts);
    //             // location.reload();
    //             this.accountChanged.next(true);
    //         })
    //     });
    // }

    /* setContracts */mountWallet(netId: any) {

        let _networkName: string = networkName[netId.toString()];
        // this.contractsService.setContractInstancesByNetwork(this.web3, _networkName);
        this.setNetworkName(_networkName);
        this.web3.currentProvider.on('accountsChanged', (accounts) => {
            console.log('accountsChanged', accounts);
            // this.disconnectProvider();
            this.accountChanged.next(true);
        });
        this.web3.currentProvider.on('networkChanged', (accounts) => {
            console.log('networkChanged', accounts);
            // location.reload();
            this.accountChanged.next(true);
        })
    }

    // getChainId(web3) {
    //     return from(web3.eth.getChainId())
    // }

    setNetworkName(networkName: string) {
        this.networkName = networkName;
        let _allowedNetworks: string[] = environment.allowedNetwork;
        if (!(_allowedNetworks.includes(networkName))) {
            //Wrong Network
            const params = [networkSettings[environment.allowedNetwork[0]]];

            window.ethereum.request({ method: 'wallet_addEthereumChain', params })
                .then(() => console.log('success'))
                .catch((error: Error) => console.log("Error", error.message));
        }
    }


    // switchNetwork() {
    //     const params = [networkSettings[environment.allowedNetwork[0]]];
    //     window.ethereum.request({
    //         method: 'wallet_switchEthereumChain', params
    //     })
    //         .then(() => console.log('Success'))
    //         .catch((error: Error) => location.reload());
    // }

    getNetworkName() {
        return this.networkName;
    }

    getChainId() {
        // this.web3 = web3;
        return from(this.web3.eth.getChainId());
    }

    isValidAddress(address: string): boolean {
        return this.web3.utils.isAddress(address);
    }

    getAccounts(): Observable<any> {
        return from(this.web3.eth.getAccounts());
    }

    fromWeiFloat(value: string): number {
        return parseFloat(this.web3.utils.fromWei(value));
    }

    toWei(value: number, unit: string = 'ether'): string {
        return this.web3.utils.toWei(value.toString(), unit);
    }
    utf8ToHex(text: string): string {
        return this.web3.utils.utf8ToHex(text);
    }
    getBalanceBnB(wallet: string): Observable<any> {
        return from(this.web3.eth.getBalance(wallet)).pipe(
            tap(/* async */ v => {
                this._balanceBnB.next({
                    float: this.fromWeiFloat(v),
                    wei: v
                })
            })
        );
    }

    updateBalanceBnB(wallet: string): void {
        this.getBalanceBnB(wallet).pipe(first()).subscribe();
    };

    get balanceBnB$(): Observable<{ float: number, wei: string }> {
        return this._balanceBnB.asObservable();
    }
    // async linkWalletPlayFab(provider) {

    //     var text = "Sign in";
    //     var msg = await this.contractService.web3.utils.utf8ToHex(text);
    //     this.accounts = this.contractService.getAccounts();
    //     var from = this.accounts[0];
    //     var params = [msg, from]
    //     var method = 'personal_sign'
    //     console.log(from)
    //     this.contractService.web3.currentProvider.sendAsync({
    //         method,
    //         params,
    //         from,
    //     }, (err: any, result: any) => {
    //         console.log('fired')
    //         if (err || result.error) {
    //             console.log(err);
    //             console.log(result)
    //             // this.isLoading = false;
    //         } else {
    //             console.log(result)
    //             let sessionToken = getCookieValue("playfab-session-token")
    //             let entityToken = getCookieValue("playfab-entity-token")
    //             let playfabId = getCookieValue("playfab-id")
    //             let post = { secret: result.result, walletId: this.accounts[0], sessionToken: sessionToken, entityToken: entityToken, playfabId: playfabId, provider: provider };
    //             this.http.post(environment.apiBaseUrl + "playfab/linkWallet.php", post)
    //                 .subscribe((item: any) => {
    //                     console.log(item)

    //                     if (item.status == "OK") {
    //                         setCookie('login', provider === "metamask" ? 'wallet' : 'magic', 30)
    //                         // this.getKryptomons('magic');
    //                     } else if (item.status == "err-wallet-used") {
    //                         // this.isLoading = false;
    //                         // this.toastr.error('This wallet is already linked to another account, please contact our support!', 'Ops! Something went wrong', { timeOut: 10000 });
    //                     } else {
    //                         // this.isLoading = false;
    //                         // this.toastr.error('Try again, or contact our team for support-lwp1', 'Ops! Something went wrong', { timeOut: 5000 });
    //                     }

    //                 }, (err) => {
    //                     // this.isLoading = false;
    //                     // this.toastr.error('Try again, or contact our team for support-lwp2', 'Ops! Something went wrong', { timeOut: 5000 });
    //                 })
    //         }
    //     })
    // }

    //LinkWalletPlayFab will be deprecated
    linkWalletPlayFab(provider: eProviders/* , callback: () => void */) {
        console.log('PlayFab 1');
        let msg = this.utf8ToHex('Sign in');
        console.log('msg:' + msg);
        this.getAccounts().subscribe(accounts => {
            console.log('accounts: ' + accounts);
            var from = accounts;
            var params = [msg, from];
            var method = 'personal_sign';
            this.web3.currentProvider.sendAsync({
                method,
                params,
                from
            }, (err: any, result: any) => {
                if (err || result.err) console.log(err || result.err);
                else {
                    let sessionToken = getCookieValue("playfab-session-token");
                    let entityToken = getCookieValue("playfab-entity-token");
                    let playfabId = getCookieValue("playfab-id");
                    let post = { secret: result.result, walletId: accounts, sessionToken: sessionToken, entityToken: entityToken, playfabId: playfabId, provider: provider };
                    this._httpClient.post(environment.apiBaseUrl + 'playfab/linkWallet.php', post).subscribe(
                        (item: any) => {
                            if (item.status == 'OK') console.log('route')/* callback() */;
                            else if (item.status == 'err-wallet-used') console.error('This wallet is already linked to another account, please contact our support!');
                            else console.error('Try again, or contact our team for support-lwp1');
                        }
                    );
                }

            });
        });
    }

    signMessage(account) {
        console.log('start signMessage');
        this.signStatus.next({ status: eStatus.pending, value: null });
        // this.getAccounts().subscribe(accounts => {
        let msg = this.utf8ToHex('Sign in');
        var from = account;
        var params = [msg, from];
        var method = 'personal_sign';
        this.web3.currentProvider.sendAsync({
            method,
            params,
            from
        }, (err: any, result: any) => {
            if (err || result.err) {
                this.signStatus.next({ status: eStatus.failed, value: err || result.err });
                // console.error(err || result.err);
            }
            else {
                let signatureHash = result.result ? result.result : result;
                let res = { result: signatureHash, account: account }
                this.signStatus.next({ status: eStatus.success, value: res });
                // console.log('result signMessage', result);
            }
        }
        );
        console.log('end signMessage');
        // });
    }

    // async getKryptomons(how) {
    //     //this.isLoading = true;
    //     console.log('getKryptomons');
    //     await this.contractService.contractInstance.methods
    //         .ownedKryptomons()
    //         .call({
    //             from: this.accounts[0],
    //         })
    //         .then((receiptV1) => {
    //             this.totalKryptomonV1 = receiptV1.length;
    //             this.contractService.contractInstanceV2.methods
    //                 .ownedKryptomons()
    //                 .call({
    //                     from: this.accounts[0],
    //                 })
    //                 .then((receipt) => {
    //                     console.log('login')
    //                     this.totalKryptomonV2 = receipt.length;
    //                     this.totalKryptomon = this.totalKryptomonV2 + this.totalKryptomonV1
    //                     var NFTid = receiptV1.concat(receipt)
    //                     console.log(NFTid)
    //                     this.identifyCustomerIo(this.accounts[0]);
    //                     let skipCookie = getCookieValue('skip-onboarding')
    //                     console.log(skipCookie)
    //                     /*if(this.totalKryptomon>0 || skipCookie=='true'){
    //                       window.location.href="./hub/kryptomons"
    //                     }else{*/
    //                     console.log('qua-sono');
    //                     this.http.get("https://api-v2.kryptomon.co/user/" + this.accounts[0] + "/kryptomons/detail?offset=0&limit=1000").subscribe(async (response: any) => {
    //                         console.log(response)
    //                         let startersAmount = 0;
    //                         let startersId = [];
    //                         let rentedAmount = 0;
    //                         let rentedId = [];
    //                         if (response.length > 0 || skipCookie == 'true') {
    //                             for (let i = 0; i < response.length; i++) {
    //                                 if (response[i].isStarter) {
    //                                     startersAmount++;
    //                                     startersId.push(response[i].tokenId)
    //                                 } else if (response[i].rental) {
    //                                     rentedAmount++;
    //                                     rentedId.push(response[i].tokenId)
    //                                 }
    //                             }

    //                             analytics.identify(this.accounts[0], {
    //                                 KryptomonNFTs: this.totalKryptomon,
    //                                 KryptomonNFTsList: NFTid,
    //                                 KryptomonNFTsV1: this.totalKryptomonV1,
    //                                 KryptomonNFTsV2: this.totalKryptomonV2,
    //                                 KryptomonRented: rentedAmount,
    //                                 KryptomonRentedList: rentedId,
    //                                 KryptomonStarter: startersAmount,
    //                                 KryptomonStarterList: startersId,
    //                                 PlayfabId: this.playfabId,
    //                                 email: this.loginEmail,
    //                                 referrer: this.refCode,
    //                                 section: 'trainerHub',
    //                                 walletProvider: how,
    //                                 ethAddress: this.accounts[0]
    //                             });


    //                             analytics.track('Login trainerHub', {
    //                                 KryptomonNFTs: this.totalKryptomon,
    //                                 KryptomonNFTsList: NFTid,
    //                                 KryptomonNFTsV1: this.totalKryptomonV1,
    //                                 KryptomonNFTsV2: this.totalKryptomonV2,
    //                                 KryptomonRented: rentedAmount,
    //                                 KryptomonRentedList: rentedId,
    //                                 KryptomonStarter: startersAmount,
    //                                 KryptomonStarterList: startersId,
    //                                 PlayfabId: this.playfabId,
    //                                 email: this.loginEmail,
    //                                 referrer: this.refCode,
    //                                 section: 'trainerHub',
    //                                 value: this.accounts[0],
    //                                 walletProvider: how
    //                             });
    //                             /* analytics.track('Login trainerHub', {section: 'trainerHub', 
    //                                value: this.accounts[0],
    //                                PlayfabId:this.playfabId, 
    //                                email: this.loginEmail, 
    //                                KryptomonNFTs:this.totalKryptomon, 
    //                                KryptomonNFTsV1:this.totalKryptomonV1, 
    //                                KryptomonNFTsV2:this.totalKryptomonV2, 
    //                                walletProvider:how, 
    //                                referrer:this.refCode });*/
    //                             window.location.href = "./hub/kryptomons"
    //                         } else {
    //                             console.log('herenow')
    //                             const listedBalance = await this.contractService.playdexContract.methods.getLenderOffersNumber("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.accounts[0]).call();
    //                             console.log(listedBalance)
    //                             const listedPromises = Array.from({ length: parseInt(listedBalance) }, async (_, i) => {
    //                                 return this.contractService.playdexContract.methods.getTokenOfLenderByIndex("0x04b0f7d5cb2ce4688497f2525748fb7a9affa394", this.accounts[0], i).call();
    //                             });
    //                             const listedTokenIds = Promise.all(listedPromises)
    //                             listedTokenIds.then((item) => {
    //                                 analytics.identify(this.accounts[0], {
    //                                     KryptomonNFTs: this.totalKryptomon,
    //                                     KryptomonNFTsList: NFTid,
    //                                     KryptomonNFTsV1: this.totalKryptomonV1,
    //                                     KryptomonNFTsV2: this.totalKryptomonV2,
    //                                     KryptomonRented: rentedAmount,
    //                                     KryptomonRentedList: rentedId,
    //                                     KryptomonStarter: startersAmount,
    //                                     KryptomonStarterList: startersId,
    //                                     PlayfabId: this.playfabId,
    //                                     email: this.loginEmail,
    //                                     referrer: this.refCode,
    //                                     section: 'trainerHub',
    //                                     walletProvider: how,
    //                                     ethAddress: this.accounts[0]
    //                                 });

    //                                 analytics.track('Login trainerHub', {
    //                                     KryptomonNFTs: this.totalKryptomon,
    //                                     KryptomonNFTsList: NFTid,
    //                                     KryptomonNFTsV1: this.totalKryptomonV1,
    //                                     KryptomonNFTsV2: this.totalKryptomonV2,
    //                                     KryptomonRented: rentedAmount,
    //                                     KryptomonRentedList: rentedId,
    //                                     KryptomonStarter: startersAmount,
    //                                     KryptomonStarterList: startersId,
    //                                     PlayfabId: this.playfabId,
    //                                     email: this.loginEmail,
    //                                     referrer: this.refCode,
    //                                     section: 'trainerHub',
    //                                     value: this.accounts[0],
    //                                     walletProvider: how
    //                                 });
    //                                 if (item.length > 0) {
    //                                     window.location.href = "./hub/kryptomons"
    //                                 } else {
    //                                     this.router.navigate(["/onboarding/start"])
    //                                 }
    //                             })

    //                         }
    //                     })
    //                     //}
    //                 }).catch((err) => {
    //                     console.log(err, 'err');
    //                 });
    //         })
    //         .catch((err) => {
    //             console.log(err, 'err');
    //         });
    // }
}

export enum eProviders {
    magic = 'magic',
    metamask = 'metamask'
}

export enum eStatus {
    notinit = 'notinit',
    pending = 'pending',
    success = 'success',
    failed = 'failed'
}

export const networkName = {
    1: "Main",
    2: "Morden",
    3: "Ropsten",
    4: "rinkeby",
    42: "Kovan",
    56: "bsc",
    97: "chapel"//testnet
}

export interface iStatus {
    status: eStatus, value: any
}

export interface InetworkSettings {
    chainId: string
    chainName: string
    nativeCurrency: {
        name: string
        symbol: string
        decimals: number
    }
    rpcUrls: string[]
    blockExplorerUrls: string[]
}

export const networkSettings: { [name in string]: InetworkSettings } = {
    bsc: {
        chainId: '0x38',
        chainName: 'Smart Chain',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
        },
        rpcUrls: ['https://bsc-dataseed.binance.org/'],
        blockExplorerUrls: ['https://bscscan.com']
    },
    rinkeby: undefined,
    chapel: {
        chainId: '0x61',
        chainName: 'Smart Chain - Testnet',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
        },
        rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
        blockExplorerUrls: ['https://testnet.bscscan.com']
    }
}